var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeftCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 27.5C8.106 27.5 2.5 21.893 2.5 15 2.5 8.108 8.106 2.5 15 2.5c6.893 0 12.5 5.608 12.5 12.5 0 6.893-5.607 12.5-12.5 12.5z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.803 20.277a.933.933 0 01-.661-.274l-4.359-4.338a.939.939 0 010-1.328l4.359-4.34a.936.936 0 111.323 1.328L13.773 15l3.692 3.675a.937.937 0 01-.662 1.602z",
    fill: "#ED1B2E"
  })));
}

export default SvgArrowLeftCircle;